export { default } from './CanaisAtendimentoTelefone';
